import {
  vObject,
  vOptional,
  type vOutput,
  vString,
} from '../validation/index.ts'

export const testInvoiceSchema = vObject({
  file: vString(),
})
export type TestInvoiceRequest = vOutput<typeof testInvoiceSchema>

export const parseInvoiceBodySchema = vObject({
  file: vString(),
  carrierId: vOptional(vString()),
})
export type ParseInvoiceBody = vOutput<typeof parseInvoiceBodySchema>
